
import { ALL_VENDORS, ADD_NEW_VENDOR, UPDATE_VENDOR, DELETE_VENDOR, FETCH_VENDORS_BY_USER, FETCH_VENDOR, START_LOADING, END_LOADING } from '../actions/constants'

const vendors = (state = { isLoading: true, vendors: [] }, action) => {
    switch (action.type) {
      case START_LOADING:
        return { ...state, isLoading: true };
      case END_LOADING:
        return { ...state, isLoading: false };
      case ALL_VENDORS:
        return { ...state, vendors: action.payload };
      case FETCH_VENDORS_BY_USER:       
        return { ...state, vendors: action.payload };

      case FETCH_VENDOR:
        return { ...state, vendor: action.payload.vendor };
      case ADD_NEW_VENDOR:
        return { ...state, vendors: [...state.vendors, action.payload] };
      case UPDATE_VENDOR:
        return { ...state, vendors: state.vendors.map((vendor) => (vendor.id === action.payload.id ? action.payload : vendor)) };
      case DELETE_VENDOR:
        return { ...state, vendors: state.vendors.filter((vendor) => vendor.id !== action.payload) };
      default:
        return state;
    }
  };

  export default vendors


